var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.707.293a1 1 0 0 1 0 1.414L3.414 7H15a1 1 0 1 1 0 2H3.414l5.293 5.293a1 1 0 1 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
    fill: "currentColor"
  })));
};

export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC43MDcxMSAwLjI5Mjg5M0M5LjA5NzYzIDAuNjgzNDE3IDkuMDk3NjMgMS4zMTY1OCA4LjcwNzExIDEuNzA3MTFMMy40MTQyMSA3SDE1QzE1LjU1MjMgNyAxNiA3LjQ0NzcyIDE2IDhDMTYgOC41NTIyOCAxNS41NTIzIDkgMTUgOUgzLjQxNDIxTDguNzA3MTEgMTQuMjkyOUM5LjA5NzYzIDE0LjY4MzQgOS4wOTc2MyAxNS4zMTY2IDguNzA3MTEgMTUuNzA3MUM4LjMxNjU4IDE2LjA5NzYgNy42ODM0MiAxNi4wOTc2IDcuMjkyODkgMTUuNzA3MUwwLjI5Mjg5MyA4LjcwNzExQy0wLjA5NzYzMTEgOC4zMTY1OCAtMC4wOTc2MzExIDcuNjgzNDIgMC4yOTI4OTMgNy4yOTI4OUw3LjI5Mjg5IDAuMjkyODkzQzcuNjgzNDIgLTAuMDk3NjMxMSA4LjMxNjU4IC0wLjA5NzYzMTEgOC43MDcxMSAwLjI5Mjg5M1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";